import axios from 'axios';
import { API_BASE_URL } from '../api';

export async function getFabricVendorConnectRequests({ page = 1, limit = 50 } = {}) {
  const token = localStorage.getItem('token');
  const res = await axios.get(`${API_BASE_URL}/fabric-vendor-connect-requests`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { page, limit },
    timeout: 20000
  });
  return res.data;
}

export async function createFabricVendorConnectRequest({
  fabricId,
  vendorId,
  requesterName,
  mobileNumber
}) {
  const token = localStorage.getItem('token');
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

  const res = await axios.post(
    `${API_BASE_URL}/fabric-vendor-connect-requests`,
    {
      fabricId,
      vendorId,
      requesterName,
      mobileNumber
    },
    {
      headers,
      timeout: 20000
    }
  );

  return res.data;
}

